module.exports = __webpack_public_path__ + "img/sumka.c0205264.svg";